module.exports = __webpack_public_path__ + "img/apk.281d6da6.png";